import styled from 'styled-components/macro';
import { Link } from 'react-router-dom';
import { themeGet } from '@styled-system/theme-get';

export const PrivacyShell = styled.div`
  min-height: 100vh;
  width: 100%;
  background: ${themeGet('colors.white')};
  padding: 40px 24px 80px;
`;

export const PrivacyInner = styled.div`
  max-width: 760px;
  margin: 0 auto;
`;

export const PrivacyLogoWrap = styled.div`
  margin-bottom: 24px;
`;

export const PrivacyPage = styled.article`
  width: 100%;
  padding: 0px 36px 40px;
  background-color: ${themeGet('colors.white')};
  border-radius: ${themeGet('radii.base')};
  color: ${themeGet('colors.text.default')};
  font-size: ${themeGet('fontSizes.sm')}px;
  line-height: 1.65;
`;

export const PrivacyTitle = styled.h1`
  margin: 0 0 12px;
  font-size: 26px;
  font-weight: ${themeGet('fontWeights.bold')};
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: ${themeGet('colors.text.default')};
  line-height: 1.3;
  text-align: center;
`;

export const PrivacyUpdated = styled.p`
  margin: 0 0 28px;
  font-size: ${themeGet('fontSizes.up')}px;
  font-weight: ${themeGet('fontWeights.semi')};
  color: ${themeGet('colors.text.default')};
`;

export const PrivacySection = styled.section`
  margin-bottom: 28px;
`;

export const PrivacyH2 = styled.h2`
  margin: 36px 0 14px;
  font-size: ${themeGet('fontSizes.md')}px;
  font-weight: ${themeGet('fontWeights.bold')};
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: ${themeGet('colors.text.default')};
  line-height: 1.35;
`;

export const PrivacyH3 = styled.h3`
  margin: 22px 0 10px;
  font-size: ${themeGet('fontSizes.up')}px;
  font-weight: ${themeGet('fontWeights.bold')};
  color: ${themeGet('colors.text.default')};
  line-height: 1.4;
  text-transform: none;
`;

export const PrivacyP = styled.p`
  margin: 0 0 14px;
  color: ${themeGet('colors.text.default')};
`;

export const PrivacyStrong = styled.strong`
  font-weight: ${themeGet('fontWeights.bold')};
  color: ${themeGet('colors.text.default')};
`;

export const PrivacyUl = styled.ul`
  margin: 0 0 16px;
  padding-left: 22px;
  list-style: disc;
`;

export const PrivacyOl = styled.ol`
  margin: 0 0 16px;
  padding-left: 22px;
  list-style: lower-alpha;
`;

export const PrivacyLi = styled.li`
  margin: 0 0 6px;
  padding-left: 4px;
  list-style: disc;
  color: ${themeGet('colors.text.default')};
`;

export const PrivacyUpper = styled(PrivacyP)`
  text-transform: uppercase;
`;

export const PrivacyAddress = styled.address`
  display: block;
  margin: 0 0 16px;
  font-style: normal;
  line-height: 1.45;
  color: ${themeGet('colors.text.default')};

  ${PrivacyStrong} {
    display: block;
    margin-bottom: 2px;
  }
`;

export const PrivacyLink = styled(Link)`
  font-weight: ${themeGet('fontWeights.semi')};
  text-decoration: underline;
  color: ${themeGet('colors.text.default')};

  &:hover {
    color: ${themeGet('colors.primary.regular')};
  }
`;

export const PrivacyMail = styled.a`
  font-weight: ${themeGet('fontWeights.semi')};
  text-decoration: underline;
  color: ${themeGet('colors.text.default')};

  &:hover {
    color: ${themeGet('colors.primary.regular')};
  }
`;
